import PropTypes from 'prop-types';

var propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(['success', 'warning', 'danger', 'informative'])
        .isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
};
var defaultProps = {
    disabled: false,
};

export { defaultProps, propTypes };
